var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.5703C18.0228 22.5703 22.5 18.0932 22.5 12.5703C22.5 7.04746 18.0228 2.57031 12.5 2.57031C6.97715 2.57031 2.5 7.04746 2.5 12.5703C2.5 18.0932 6.97715 22.5703 12.5 22.5703Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59 9.57027C9.8251 8.90194 10.2891 8.33838 10.9 7.9794C11.5108 7.62043 12.2289 7.48921 12.9272 7.60898C13.6255 7.72876 14.2588 8.0918 14.7151 8.6338C15.1713 9.1758 15.4211 9.86179 15.42 10.5703C15.42 12.5703 12.42 13.5703 12.42 13.5703",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5703H12.51",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c793ac588a0af8cc3b5115e4a87f64e7.svg";
export { ForwardRef as ReactComponent };